/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_ProductInputs */

const en_settings_payments_product = /** @type {(inputs: Settings_Payments_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const zh_settings_payments_product = /** @type {(inputs: Settings_Payments_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Settings_Payments_ProductInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_product = /** @type {((inputs?: Settings_Payments_ProductInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_ProductInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_product(inputs)
	return zh_settings_payments_product(inputs)
});
export { settings_payments_product as "settings.payments.product" }